import { HeaderMobile } from '@/widgets/header/header-mobile/header-mobile.js';
import { HeaderSearchMobile } from '@/widgets/header/header-search-mobile/header-search-mobile.js';
import {HeaderSearchForm} from '@/widgets/header/header-search-form/header-search-form.js';
import {HeaderLocation} from '@/widgets/header/header-location/header-location.js';
import {HeaderDesktop} from '@/widgets/header/header-desktop/header-desktop.js';
import {HeaderCatalog} from '@/widgets/header/header-catalog/header-catalog.js';

window.app = window.app || {};

export const header = () => {
	window.app.headerMobile = new HeaderMobile();
	window.app.headerSearchMobile = new HeaderSearchMobile();
	document.querySelectorAll('.header-search-form').forEach((form) => new HeaderSearchForm(form));
	window.app.headerLocation = new HeaderLocation();
	window.app.headerDesktop = new HeaderDesktop;
	document.querySelectorAll('.header-desktop .header-catalog').forEach((catalog) => new HeaderCatalog(catalog));
};
